import $ from 'jquery';
import slick from 'slick-carousel';


export default (selector) => {

    if ($(".page-template-template-aree").length > 0) {

        $("#slider-service-0").slick(
            { "centerMode": true, "slidesToShow": 1, "slidesToScroll": 1, "focusOnSelect": true, "responsive": [{ "breakpoint": 1400, "settings": { "slidesToShow": 1, "slidesToScroll": 1 } }, { "breakpoint": 900, "settings": { "slidesToShow": 1, "slidesToScroll": 1 } }, { "breakpoint": 700, "settings": { "slidesToShow": 1, "slidesToScroll": 1 } }] }
        );

        $('a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
            // newly activated tab
            // e.relatedTarget // previous active tab

            $("#" + $(e.relatedTarget).attr('id').replace("-tab", "")).find('.component-carousel-aree-foto').slick('unslick');
            $("#" + $(e.target).attr('id').replace("-tab", "")).find('.component-carousel-aree-foto').slick(
                { "centerMode": true, "slidesToShow": 1, "slidesToScroll": 1, "focusOnSelect": true, "responsive": [{ "breakpoint": 1400, "settings": { "slidesToShow": 1, "slidesToScroll": 1 } }, { "breakpoint": 900, "settings": { "slidesToShow": 1, "slidesToScroll": 1 } }, { "breakpoint": 700, "settings": { "slidesToShow": 1, "slidesToScroll": 1 } }] }
            );
        });
    }

};



// WEBPACK FOOTER //
// ./scripts/libs/multipleSlidersInit.js